import React, { useRef } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Monitor, Crop, Upload } from 'lucide-react';

interface AddButtonMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onFullScreenshot: () => void;
  onAreaScreenshot: () => void;
  onUploadImage: () => void;
}

export const AddButtonMenu: React.FC<AddButtonMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onFullScreenshot,
  onAreaScreenshot,
  onUploadImage,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          minWidth: '220px',
          backgroundColor: '#fff',
        },
      }}
    >
      <MenuItem
        onClick={() => {
          onFullScreenshot();
          onClose();
        }}
        sx={{
          py: 1.5,
          px: 2,
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Monitor size={20} />
        </ListItemIcon>
        <ListItemText
          primary="Full screen"
          slotProps={{
            primary: {
              fontSize: 14,
              fontWeight: 500,
            },
          }}
        />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onAreaScreenshot();
          onClose();
        }}
        sx={{
          py: 1.5,
          px: 2,
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Crop size={20} />
        </ListItemIcon>
        <ListItemText
          primary="Selected area"
          slotProps={{
            primary: {
              fontSize: 14,
              fontWeight: 500,
            },
          }}
        />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onUploadImage();
          onClose();
        }}
        sx={{
          py: 1.5,
          px: 2,
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Upload size={20} />
        </ListItemIcon>
        <ListItemText
          primary="Upload image"
          slotProps={{
            primary: {
              fontSize: 14,
              fontWeight: 500,
            },
          }}
        />
      </MenuItem>
    </Menu>
  );
};

